import { render, staticRenderFns } from "./DepositPromoCode.vue?vue&type=template&id=c771bde6&scoped=true"
import script from "./DepositPromoCode.vue?vue&type=script&lang=js"
export * from "./DepositPromoCode.vue?vue&type=script&lang=js"
import style0 from "./DepositPromoCode.vue?vue&type=style&index=0&id=c771bde6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c771bde6",
  null
  
)

export default component.exports